import { useEffect, useState } from "react";
import "../../css/FormularioActor.css";
import { NMTipoDocumento } from "../../shared/Denominaciones";
import axios from "axios";
import { HEADERS_API } from "../NuevaGuia";
import { ListaDepartamentos, ListaDistritos, ListaProvincias } from "../../shared/Ubigeo";
import { ValidarNum } from "../../shared/Regex";

export default function FormularioActor({funcionAgregar, funcionCancelar, tipoActor, listaDocumentos}){

    //#region HOOKS STATE
    //==========================================================================================
    const[tipoDoc, setTipoDoc] = useState("1");
    const[nroDoc, setNroDoc] = useState("");
    const[razSoc, setRazSoc] = useState("");
    const[direccion, setDireccion] = useState("");
    const[ubigeo, setUbigeo] = useState("010101");
    const[dpto, setDpto] = useState("01");
    const[prov, setProv] = useState("01");
    const[dist, setDist] = useState("01");

    // Estados de contenido
    const[indicadorBusqueda, setIndicadorBusqueda] = useState(<></>);

    // Estados de validación
    const[datosCompletos, setDatosCompletos] = useState(true);

    //#endregion

    //#region HOOKS EFFECT
    //==========================================================================================
    useEffect(()=>{
        if(tipoDoc == '1' && nroDoc.length == 8){
            // ConsultaDniMidis();
        }

        if(tipoDoc == '6' && nroDoc.length == 11){
            ConsultaRucSunat();
        }
    },[nroDoc]);

    useEffect(()=>{
        try {
            if(tipoDoc == "" || nroDoc == "" || razSoc == "" || direccion == "" || ubigeo == ""){
                throw new Error();
            }

            HandlerDatosCompletos(false);
        } catch (error) {
            HandlerDatosCompletos(true);
        }
    },[tipoDoc, nroDoc, razSoc, direccion, ubigeo]);

    // Actualizar ubigeo y reestablecer inferiores al cambiar departamento, provincia o distrito de partida
    useEffect(()=>{
        HandlerDist("01");
        HandlerProv("01");
        HandlerUbigeo(`${dpto}${prov}${dist}`);
    },[dpto]);
    useEffect(()=>{
        HandlerDist("01");
        HandlerUbigeo(`${dpto}${prov}${dist}`);
    },[prov]);
    useEffect(()=>{
        HandlerUbigeo(`${dpto}${prov}${dist}`);
    },[dist]);

    //#endregion

    //#region HANDLERS
    //==========================================================================================
    function HandlerTipoDoc(codigo){
        setTipoDoc(codigo);
    }
    function HandlerNroDoc(valor){
        if(ValidarNum(valor) || valor == ""){
            setNroDoc(valor);
        }
    }
    function HandlerRazSoc(valor){
        setRazSoc(valor.toUpperCase());
    }
    function HandlerDireccion(direccion){
        setDireccion(direccion.toUpperCase());
    }
    function HandlerUbigeo(codigo){
        setUbigeo(codigo);
    }
    function HandlerDpto(codigo){
        setDpto(codigo);
    }
    function HandlerProv(codigo){
        setProv(codigo);
    }
    function HandlerDist(codigo){
        setDist(codigo);
    }
    function HandlerIndicadorBusqueda(valor){
        setIndicadorBusqueda(valor);
    }
    function HandlerDatosCompletos(valor){
        setDatosCompletos(valor);
    }
    //#endregion

    //#region FUNCIONES
    //==========================================================================================

    // FUNCIONES ASÍNCRONAS

    async function ConsultaRucSunat(){
        try{
            //Vaciar valores y mostrar spinner de carga
            HandlerRazSoc("");
            HandlerDireccion("");
            HandlerUbigeo("010101");
            HandlerIndicadorBusqueda(<>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div></>
            );

            const response = await axios.get(URL_CONSULTA_RUC_SUNAT, {
                headers: HEADERS_API,
                params:{
                    ruc: nroDoc
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            if(response.data.mensajeError != null){
                throw new Error(response.data.mensajeError);
            }

            HandlerRazSoc(response.data.nombre);
            HandlerDireccion(response.data.dirCompleta);
            HandlerIndicadorBusqueda(<></>);

        }catch(error){
            console.log(error.message);
            HandlerIndicadorBusqueda(<></>);
        }
    }

    async function ConsultaDniMidis(){
        try{
            //Vaciar valores y mostrar spinner de carga
            HandlerRazSoc("");
            HandlerDireccion("");
            HandlerUbigeo("010101");
            HandlerIndicadorBusqueda(<>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div></>
            );

            const response = await axios.get(URL_CONSULTA_DNI_MIDIS, {
                headers: HEADERS_API,
                params:{
                    dni: nroDoc
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            if(response.data.mensajeError != null){
                throw new Error(response.data.mensajeError);
            }

            HandlerRazSoc(`${response.data.vNombres} ${response.data.vApePaterno} ${response.data.vApeMaterno}`);
            HandlerDireccion(response.data.vDireccion);
            HandlerIndicadorBusqueda(<></>);

        }catch(error){
            console.log(error.message);
            HandlerIndicadorBusqueda(<></>);
        }
    }

    const registrarCliente = async () =>{
        try{
            let response = await axios.post(URL_INSERTAR_CLIENTE,{
                codigoUsuario: "",
                tipoDoc: tipoDoc,
                nroDoc: nroDoc,
                nombre: razSoc,
                esProveedor: tipoActor,
                direccion: direccion,
                ubigeo: ubigeo
            },{
                headers:HEADERS_API
            }).catch(error=>{
                throw new Error(error.message);
            });
            // console.log(response.data);
        }catch(error){
            console.log(error);
        }
    }

    // Ejecutar función recibida como parámetro
    const ejecutarFuncion = async () => {
        if(direccion.length > 5){
            funcionAgregar(tipoDoc, nroDoc, razSoc, direccion, ubigeo);
            await registrarCliente();
        }else{
            funcionAgregar(tipoDoc, nroDoc, razSoc, "", ubigeo);
        }
        funcionCancelar();
    }
    //#endregion

    //#region CONTENIDO
    //==========================================================================================
    return(<>
    <div id="modal-actor" className="d-flex justify-content-center align-items-center">
        <div id="formulario-registro">
            <div className="bg-primary text-white p-2 fs-4">
                NUEVO {tipoActor == 1 ? 'PROVEEDOR' : 'CLIENTE'}
            </div>
            <div className="p-2">
                <div className="row">
                    <div className="pb-3 col-12 col-md-6">
                        <select onChange={e => HandlerTipoDoc(e.target.value)} value={tipoDoc} id="tipo-doc" type="select" className="form-select f-actor-texto" placeholder="Tipo de Documento" >
                            {listaDocumentos}                          
                        </select>
                    </div>
                    <div className="pb-3 col-9 col-md-4">
                        <input onChange={e => HandlerNroDoc(e.target.value)} value={nroDoc} maxLength={15} id="nro-doc" type="text" className="form-control" placeholder="N° Documento" autoComplete="off" />                        
                    </div>
                    <div className="pb-3 col-2">
                        {indicadorBusqueda}
                    </div>
                    <div className="px-3 col-12">
                        <label htmlFor="f-nombre" className="fw-semibold">Nombre o Razón Social</label>
                        <input onChange={e=>HandlerRazSoc(e.target.value)} value={razSoc} maxLength={120} type="text" className="form-control f-actor-texto" id="f-nombre" autoComplete="off" />
                    </div>
                    <div className="px-3 col-12">
                        <label htmlFor="f-direccion" className="fw-semibold">Direccion</label>
                        <input onChange={e=>HandlerDireccion(e.target.value)} value={direccion} maxLength={150} type="text" className="form-control f-actor-texto" id="f-direccion" autoComplete="off" />
                    </div>
                    <div className="col-12 col-md-4 py-3">
                        <label htmlFor="f-select-dpto" className="fw-semibold">Departamento</label>
                        <select value={dpto} onChange={e=>HandlerDpto(e.target.value)} className="form-select f-actor-texto" id="f-select-dpto">
                            <ListaDepartamentos/>
                        </select>
                    </div>
                    <div className="col-12 col-md-4 py-3">
                        <label htmlFor="f-select-prov" className="fw-semibold">Provincia</label>
                        <select value={prov} onChange={e=>HandlerProv(e.target.value)} className="form-select f-actor-texto" id="f-select-prov">
                            <ListaProvincias departamento={dpto}/>
                        </select>
                    </div>
                    <div className="col-12 col-md-4 py-3">
                        <label htmlFor="f-select-dist" className="fw-semibold">Distrito</label>
                        <select value={dist} onChange={e=>HandlerDist(e.target.value)} className="form-select f-actor-texto" id="f-select-dist">
                            <ListaDistritos provincia={prov} departamento={dpto}/>
                        </select>
                    </div>
                    <div className="p-2 d-flex justify-content-around">
                        <button onClick={funcionCancelar} className="btn btn-secondary">Cancelar</button>
                        <button onClick={ejecutarFuncion} disabled={datosCompletos} className="btn btn-primary">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>);
    //#endregion
}

//#region CONSTANTES
//==========================================================================================
const URL_CONSULTA_RUC_SUNAT = process.env.REACT_APP_URL_CONSULTA_RUC_SUNAT;
const URL_CONSULTA_DNI_MIDIS = process.env.REACT_APP_URL_CONSULTA_DNI_MIDIS;
const URL_INSERTAR_CLIENTE = process.env.REACT_APP_URL_INSERTAR_CLIENTE;
//#endregion
